import { EditOutlined } from '@ant-design/icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button, Flex, Space, Tag, Tooltip, Typography } from 'antd';

import {
  IS_DELETED,
  KEY,
  U_ACTION,
  U_DESCRIPTION,
  U_NAME,
} from '@app/constants';
import type { NTags } from '@app/types/Tags';
import { getContrastYIQ } from '@app/utils';

import type { IconProp } from '@fortawesome/fontawesome-svg-core';

const { Text } = Typography;

export const adaptDataToTable = (
  data: Array<NTags.Tag>,
  handleEdit: (id: number) => void,
  hasUserRight: boolean
) => {
  return data.map((tag: NTags.Tag) => {
    const { Id, Name, Description, IconId, IsSystem, IsDeleted } = tag;

    return {
      [KEY]: String(Id),
      [U_NAME]: (
        <Flex vertical gap={8}>
          <Tag
            icon={
              <FontAwesomeIcon
                icon={IconId as IconProp}
                style={{ marginRight: '5px', color: getContrastYIQ(tag.Color) }}
              />
            }
            color={tag.Color || 'white'}
            data-testid="tag-name"
          >
            <Text style={{ color: getContrastYIQ(tag.Color) }}>{Name}</Text>
          </Tag>
          {IsDeleted && <Text type="danger">В архиве</Text>}
        </Flex>
      ),
      [U_DESCRIPTION]: (
        <div style={{ maxWidth: '600px' }} data-testid="tag-description">
          {Description}
        </div>
      ),
      [U_ACTION]: (
        <Space>
          {!IsSystem && hasUserRight && (
            <Tooltip title="Редактировать">
              <Button
                icon={<EditOutlined />}
                onClick={() => handleEdit(Id)}
                data-testid="edit-tag"
              />
            </Tooltip>
          )}
        </Space>
      ),
      [IS_DELETED]: IsDeleted,
    };
  });
};
